import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#593223', // dark brown
            secondary: '#007581', // dark blue
            accent: '#63acb6', // light blue
            error: '#951c22', // dark red
          },
        },
      },
});
